module.exports = __webpack_public_path__ + "img/DSC0320.6b8822bc.jpg";